'use strict';

app.config(function ($popupProvider) {

  $popupProvider.define('pdf-remove', function () {
    return /*@ngInject*/ {
      windowClass: 'pdf-remove-modal',
      templateUrl: '/app/states/pdf/pdf-remove.html'
    };
  });

  $popupProvider.define('pdf', function (params) {
    return /*@ngInject*/ {
      windowClass: 'pdf-modal',
      templateUrl: '/app/states/pdf/pdf.html',
      controller: function ($scope, $window, $document, $timeout, $http, $state, Documents) {

        var body = $document.find('body');

        var iframe = function (src) {
          var frame = angular.element('<iframe style="display:none;"></iframe>');
          frame.attr('src', src);
          body.append(frame);
          return frame;
        };

        var download = function (src) {
          iframe(src);
        };

        var print = function (src) {
          iframe(src).on('load', function () {
            try {
              this.contentWindow.print();
            } catch (e) {
              $window.alert(e);
            }
          });
        };

        if (params.type == 'inline') {
          $http.get('/api/v1/files/' + params.src._id).then(function (resp) {
            var file = resp.data;
            $scope.pdf = {
              isUserDoc: !!file.userDoc,
              userDoc: file.userDoc,
              images: file.images,
              link: '/api/v1/files/' + params.src._id + '/pdf?download=true',
              download: function () {
                download('/api/v1/files/' + params.src._id + '/pdf?download=true');
              },
              print: function () {
                print('/api/v1/files/' + params.src._id + '/pdf');
              },
              save: function () {
                var name = '';
                if ($scope.module) { name += $scope.module.name + ' Module → '; }
                if ($scope.lesson) { name += $scope.lesson.name + ' → '; }
                if ($scope.byte) { name += $scope.byte.name + ' → '; }
                name += file.meta.originalName;
                var doc = {
                  name: name,
                  sourceType: 'inline',
                  sourceParams: {
                    instanceId: file.meta.instanceId,
                    fileId: file._id
                  }
                };
                Documents.save(doc).then(function () {
                  $scope.pdf.isUserDoc = true;
                  $scope.pdf.userDoc = resp.data;
                });
              },
              remove: function () {
                $scope.$popup('pdf-remove').then(function () {
                  Documents.remove($scope.pdf.userDoc._id).then(function () {
                    $scope.pdf.isUserDoc = false;
                    $scope.pdf.userDoc = null;
                  });
                });
              }
            };
          });
        } else {
          $scope.pdf = {
            isUserDoc: true,
            images: params.src.links.images,
            link: '/api/v1/me/documents/' + params.src._id + '/pdf?download=true',
            download: function () {
              download('/api/v1/me/documents/' + params.src._id + '/pdf?download=true');
            },
            print: function () {
              print('/api/v1/me/documents/' + params.src._id + '/pdf');
            },
            remove: function () {
              $scope.$popup('pdf-remove').then(function () {
                Documents.remove(params.src._id).then(function () {
                  $scope.$dismiss();
                  $state.reload();
                });
              });
            }
          };
        }
      }
    };
  });

});
